import * as tslib_1 from "tslib";
import { EventEmitter, ElementRef } from '@angular/core';
import { ItmAbstractControl } from '../itm-abstract-control';
var ItmComboboxComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ItmComboboxComponent, _super);
    function ItmComboboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.myChange = new EventEmitter();
        return _this;
    }
    ItmComboboxComponent.prototype.getControlRef = function () {
        return this.controlRef;
    };
    ItmComboboxComponent.prototype.myOnChange = function (v) {
        this.onChange(v);
        this.myChange.emit(v);
    };
    return ItmComboboxComponent;
}(ItmAbstractControl));
export { ItmComboboxComponent };
